var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationTooltip = function SvgGeneralInformationTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12M21 12c0-4.963-4.037-9-9-9s-9 4.037-9 9 4.037 9 9 9 9-4.037 9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.064 7.5C10.107 7.5 9.061 8.668 9 10.193h1.397c.06-.89.662-1.451 1.593-1.451.924 0 1.525.56 1.525 1.322 0 .696-.29 1.087-1.107 1.58-.924.553-1.336 1.16-1.302 2.112l.007.86h1.396v-.732c0-.694.25-1.052 1.12-1.565.892-.534 1.418-1.27 1.418-2.315 0-1.445-1.201-2.504-2.983-2.504M11.819 15.631a.865.865 0 1 0-.001 1.73.865.865 0 0 0 0-1.73"
  }))));
};
export default SvgGeneralInformationTooltip;